import { render } from "./ProductComponent.vue?vue&type=template&id=f5196504"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5196504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5196504', __exports__)) {
    api.reload('f5196504', __exports__)
  }
  
  module.hot.accept("./ProductComponent.vue?vue&type=template&id=f5196504", () => {
    api.rerender('f5196504', render)
  })

}


export default __exports__